import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import interstellar from "./assets/550739.jpg";
import { useWindowSize } from "./hooks/useWindowSize";

function MovieBox({ darkMode }) {
  return (
    <div className={`movie-container ${darkMode ? "dark" : "light"}`}>
      <div className="movie-box">
        <img src={interstellar} alt="Stranger Things" />

        <div className="movie-info">
          <h2>interstellar</h2>
          <p>Genre: Sci-Fi</p>
          <p>ukan varskvlavebi xo magaria? hihihi</p>
        </div>
      </div>
    </div>
  );
}

function App() {
  const { width } = useWindowSize();
  const isDesktop = width >= 768;

  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem("darkMode");
    return saved ? JSON.parse(saved) : true;
  });

  const effectiveDarkMode = isDesktop ? darkMode : true;

  const toggleMode = () => {
    if (!isDesktop) return;

    setDarkMode((prev) => {
      localStorage.setItem("darkMode", JSON.stringify(!prev));
      return !prev;
    });
  };

  return (
    <>
      {isDesktop && (
        <button className="toggle-btn" onClick={toggleMode}>
          Switch to {darkMode ? "Light" : "Dark"} Mode
        </button>
      )}

      <MovieBox darkMode={effectiveDarkMode} />
    </>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
